import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Database, CheckCircle } from 'lucide-react';
import { postManualInput } from '../manualInputs/useManualInput';

const Box = styled.div`
  padding: 24px;
  color: rgba(255, 255, 255, 0.9);
`;

const Button = styled.button`
  margin-top: 12px;
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid rgba(59, 130, 246, 0.5);
  background: rgba(59, 130, 246, 0.15);
  color: #9cf;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export default function ScenarioCatalogAdmin({ instanceId, locked = false, catalogSlug = 'waasa-trendit', onApplied }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSeed = async () => {
    if (!instanceId || locked || !catalogSlug) return;
    setBusy(true);
    setError(null);
    try {
      const data = await postManualInput(instanceId, 'scenario_catalog', 'apply', { catalogSlug, replaceExisting: true });
      setResult(data.seed);
      onApplied?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box>
      <h3 style={{ margin: '0 0 8px', fontSize: 16 }}>Trendikatalogi</h3>
      <p style={{ margin: 0, fontSize: 13, opacity: 0.75 }}>
        Lataa vaikutuskartan pohjalle nykytrendit ja niiden muuttujat katalogista{' '}
        <strong>{catalogSlug}</strong>. Ei tulevaisuuskuvia — yksi tasainen muuttujalista per trendi.
      </p>
      <Button type="button" onClick={handleSeed} disabled={busy || locked || !catalogSlug}>
        <Database size={16} /> {busy ? 'Ladataan…' : 'Lataa trendit'}
      </Button>
      {result && (
        <p style={{ marginTop: 12, fontSize: 13, color: '#9cf' }}>
          <CheckCircle size={14} style={{ verticalAlign: 'middle' }} />{' '}
          {result.scenariosUpserted ?? 0} trendiä, {result.variablesInserted ?? 0} muuttujaa
        </p>
      )}
      {error && <p style={{ marginTop: 8, color: '#f88', fontSize: 13 }}>{error}</p>}
    </Box>
  );
}
